import { useTheme } from "next-themes";
import { X } from "lucide-react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      icons={{
        close: <X className="size-4 shrink-0" strokeWidth={2.25} aria-hidden />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast relative overflow-visible border pr-10 shadow-md group-[.toaster]:border-border group-[.toaster]:bg-background group-[.toaster]:text-foreground",
          title: "group-[.toast]:font-medium",
          description: "group-[.toast]:text-muted-foreground",
          success:
            "!border-emerald-500/55 !bg-emerald-50 !text-emerald-950 dark:!border-emerald-500/45 dark:!bg-emerald-950/55 dark:!text-emerald-50 [&_.description]:!text-emerald-900/90 dark:[&_.description]:!text-emerald-100/90",
          error:
            "!border-red-500/55 !bg-red-50 !text-red-950 dark:!border-red-500/45 dark:!bg-red-950/55 dark:!text-red-50 [&_.description]:!text-red-900/90 dark:[&_.description]:!text-red-100/90",
          closeButton:
            "!absolute !right-2 !top-2 !left-auto !translate-y-0 !border-0 !bg-transparent !p-1 !text-current opacity-70 !shadow-none transition-opacity hover:!bg-black/10 hover:!opacity-100 dark:hover:!bg-white/15 [&_svg]:pointer-events-none",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
